import React from 'react';

type Props = {
  printPreview?: boolean;
};

const ReportPrintPageBreak: React.FC<Props> = ({ printPreview = false }) => {
  return printPreview ? (
    <div className="relative my-12 -mx-12">
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div className="w-full border-t border-gray-300" />
      </div>
      <div className="relative flex justify-center">
        <span className="px-2 bg-white text-sm text-gray-400 font-light">Page break</span>
      </div>
    </div>
  ) : null;
};

export default ReportPrintPageBreak;
